module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp2_3009.6f976134.png";